import * as o from "react";
import * as Ue from "react-dom";
import { N as O, c as he, a as ne, u as A, d as V, D as J, e as pe, R as re, f as ae, g as M, h as Ie, m as ve, i as ye, j as we, k as Ee, A as Ve, M as Me, l as He, O as Ke, n as Be, o as je, L as ze, p as We, q as ce, r as Ye, s as qe, t as Ge, v as Je, w as Xe, x as $e, y as Qe, z as Ze, B as et, C as tt, b as nt, E as rt, F as at, G as ot, H as it } from "./index-Czzd9rjU.js";
import { s as P, w as H, c as q, i as E, j as st, m as te, a as Se, b as ge, d as Re, E as be, I as lt, A as ut, e as ct, f as ft, g as dt, h as mt, k as ht, l as pt, p as vt, r as yt, n as wt, o as Et, q as St } from "./router-lfyopgBI.js";
/**
 * React Router DOM v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function b() {
  return b = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, b.apply(this, arguments);
}
function oe(e, t) {
  if (e == null) return {};
  var n = {}, a = Object.keys(e), r, s;
  for (s = 0; s < a.length; s++)
    r = a[s], !(t.indexOf(r) >= 0) && (n[r] = e[r]);
  return n;
}
const W = "get", Y = "application/x-www-form-urlencoded";
function X(e) {
  return e != null && typeof e.tagName == "string";
}
function gt(e) {
  return X(e) && e.tagName.toLowerCase() === "button";
}
function Rt(e) {
  return X(e) && e.tagName.toLowerCase() === "form";
}
function bt(e) {
  return X(e) && e.tagName.toLowerCase() === "input";
}
function Nt(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function Ct(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !Nt(e);
}
function G(e) {
  return e === void 0 && (e = ""), new URLSearchParams(typeof e == "string" || Array.isArray(e) || e instanceof URLSearchParams ? e : Object.keys(e).reduce((t, n) => {
    let a = e[n];
    return t.concat(Array.isArray(a) ? a.map((r) => [n, r]) : [[n, a]]);
  }, []));
}
function Tt(e, t) {
  let n = G(e);
  return t && t.forEach((a, r) => {
    n.has(r) || t.getAll(r).forEach((s) => {
      n.append(r, s);
    });
  }), n;
}
let j = null;
function _t() {
  if (j === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), j = !1;
    } catch {
      j = !0;
    }
  return j;
}
const Lt = /* @__PURE__ */ new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function ee(e) {
  return e != null && !Lt.has(e) ? (process.env.NODE_ENV !== "production" && H(!1, '"' + e + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + Y + '"')), null) : e;
}
function xt(e, t) {
  let n, a, r, s, i;
  if (Rt(e)) {
    let u = e.getAttribute("action");
    a = u ? P(u, t) : null, n = e.getAttribute("method") || W, r = ee(e.getAttribute("enctype")) || Y, s = new FormData(e);
  } else if (gt(e) || bt(e) && (e.type === "submit" || e.type === "image")) {
    let u = e.form;
    if (u == null)
      throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
    let f = e.getAttribute("formaction") || u.getAttribute("action");
    if (a = f ? P(f, t) : null, n = e.getAttribute("formmethod") || u.getAttribute("method") || W, r = ee(e.getAttribute("formenctype")) || ee(u.getAttribute("enctype")) || Y, s = new FormData(u, e), !_t()) {
      let {
        name: l,
        type: c,
        value: d
      } = e;
      if (c === "image") {
        let h = l ? l + "." : "";
        s.append(h + "x", "0"), s.append(h + "y", "0");
      } else l && s.append(l, d);
    }
  } else {
    if (X(e))
      throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    n = W, a = null, r = Y, i = e;
  }
  return s && r === "text/plain" && (i = s, s = void 0), {
    action: a,
    method: n.toLowerCase(),
    encType: r,
    formData: s,
    body: i
  };
}
const Ft = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "viewTransition"], Pt = ["aria-current", "caseSensitive", "className", "end", "style", "to", "viewTransition", "children"], Dt = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "viewTransition"], Ot = "6";
try {
  window.__reactRouterVersion = Ot;
} catch {
}
function At(e, t) {
  return Se({
    basename: t == null ? void 0 : t.basename,
    future: b({}, t == null ? void 0 : t.future, {
      v7_prependBasename: !0
    }),
    history: ge({
      window: t == null ? void 0 : t.window
    }),
    hydrationData: (t == null ? void 0 : t.hydrationData) || Ne(),
    routes: e,
    mapRouteProperties: ve,
    dataStrategy: t == null ? void 0 : t.dataStrategy,
    patchRoutesOnNavigation: t == null ? void 0 : t.patchRoutesOnNavigation,
    window: t == null ? void 0 : t.window
  }).initialize();
}
function kt(e, t) {
  return Se({
    basename: t == null ? void 0 : t.basename,
    future: b({}, t == null ? void 0 : t.future, {
      v7_prependBasename: !0
    }),
    history: Re({
      window: t == null ? void 0 : t.window
    }),
    hydrationData: (t == null ? void 0 : t.hydrationData) || Ne(),
    routes: e,
    mapRouteProperties: ve,
    dataStrategy: t == null ? void 0 : t.dataStrategy,
    patchRoutesOnNavigation: t == null ? void 0 : t.patchRoutesOnNavigation,
    window: t == null ? void 0 : t.window
  }).initialize();
}
function Ne() {
  var e;
  let t = (e = window) == null ? void 0 : e.__staticRouterHydrationData;
  return t && t.errors && (t = b({}, t, {
    errors: Ut(t.errors)
  })), t;
}
function Ut(e) {
  if (!e) return null;
  let t = Object.entries(e), n = {};
  for (let [a, r] of t)
    if (r && r.__type === "RouteErrorResponse")
      n[a] = new be(r.status, r.statusText, r.data, r.internal === !0);
    else if (r && r.__type === "Error") {
      if (r.__subType) {
        let s = window[r.__subType];
        if (typeof s == "function")
          try {
            let i = new s(r.message);
            i.stack = "", n[a] = i;
          } catch {
          }
      }
      if (n[a] == null) {
        let s = new Error(r.message);
        s.stack = "", n[a] = s;
      }
    } else
      n[a] = r;
  return n;
}
const $ = /* @__PURE__ */ o.createContext({
  isTransitioning: !1
});
process.env.NODE_ENV !== "production" && ($.displayName = "ViewTransition");
const Q = /* @__PURE__ */ o.createContext(/* @__PURE__ */ new Map());
process.env.NODE_ENV !== "production" && (Q.displayName = "Fetchers");
const It = "startTransition", L = o[It], Vt = "flushSync", fe = Ue[Vt], Mt = "useId", de = o[Mt];
function Ht(e) {
  L ? L(e) : e();
}
function U(e) {
  fe ? fe(e) : e();
}
class Kt {
  constructor() {
    this.status = "pending", this.promise = new Promise((t, n) => {
      this.resolve = (a) => {
        this.status === "pending" && (this.status = "resolved", t(a));
      }, this.reject = (a) => {
        this.status === "pending" && (this.status = "rejected", n(a));
      };
    });
  }
}
function Bt(e) {
  let {
    fallbackElement: t,
    router: n,
    future: a
  } = e, [r, s] = o.useState(n.state), [i, u] = o.useState(), [f, l] = o.useState({
    isTransitioning: !1
  }), [c, d] = o.useState(), [h, S] = o.useState(), [w, N] = o.useState(), g = o.useRef(/* @__PURE__ */ new Map()), {
    v7_startTransition: C
  } = a || {}, m = o.useCallback((y) => {
    C ? Ht(y) : y();
  }, [C]), p = o.useCallback((y, T) => {
    let {
      deletedFetchers: R,
      flushSync: B,
      viewTransitionOpts: x
    } = T;
    R.forEach((F) => g.current.delete(F)), y.fetchers.forEach((F, ke) => {
      F.data !== void 0 && g.current.set(ke, F.data);
    });
    let Ae = n.window == null || n.window.document == null || typeof n.window.document.startViewTransition != "function";
    if (!x || Ae) {
      B ? U(() => s(y)) : m(() => s(y));
      return;
    }
    if (B) {
      U(() => {
        h && (c && c.resolve(), h.skipTransition()), l({
          isTransitioning: !0,
          flushSync: !0,
          currentLocation: x.currentLocation,
          nextLocation: x.nextLocation
        });
      });
      let F = n.window.document.startViewTransition(() => {
        U(() => s(y));
      });
      F.finished.finally(() => {
        U(() => {
          d(void 0), S(void 0), u(void 0), l({
            isTransitioning: !1
          });
        });
      }), U(() => S(F));
      return;
    }
    h ? (c && c.resolve(), h.skipTransition(), N({
      state: y,
      currentLocation: x.currentLocation,
      nextLocation: x.nextLocation
    })) : (u(y), l({
      isTransitioning: !0,
      flushSync: !1,
      currentLocation: x.currentLocation,
      nextLocation: x.nextLocation
    }));
  }, [n.window, h, c, g, m]);
  o.useLayoutEffect(() => n.subscribe(p), [n, p]), o.useEffect(() => {
    f.isTransitioning && !f.flushSync && d(new Kt());
  }, [f]), o.useEffect(() => {
    if (c && i && n.window) {
      let y = i, T = c.promise, R = n.window.document.startViewTransition(async () => {
        m(() => s(y)), await T;
      });
      R.finished.finally(() => {
        d(void 0), S(void 0), u(void 0), l({
          isTransitioning: !1
        });
      }), S(R);
    }
  }, [m, i, c, n.window]), o.useEffect(() => {
    c && i && r.location.key === i.location.key && c.resolve();
  }, [c, h, r.location, i]), o.useEffect(() => {
    !f.isTransitioning && w && (u(w.state), l({
      isTransitioning: !0,
      flushSync: !1,
      currentLocation: w.currentLocation,
      nextLocation: w.nextLocation
    }), N(void 0));
  }, [f.isTransitioning, w]), o.useEffect(() => {
    process.env.NODE_ENV !== "production" && H(t == null || !n.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
  }, []);
  let v = o.useMemo(() => ({
    createHref: n.createHref,
    encodeLocation: n.encodeLocation,
    go: (y) => n.navigate(y),
    push: (y, T, R) => n.navigate(y, {
      state: T,
      preventScrollReset: R == null ? void 0 : R.preventScrollReset
    }),
    replace: (y, T, R) => n.navigate(y, {
      replace: !0,
      state: T,
      preventScrollReset: R == null ? void 0 : R.preventScrollReset
    })
  }), [n]), _ = n.basename || "/", k = o.useMemo(() => ({
    router: n,
    navigator: v,
    static: !1,
    basename: _
  }), [n, v, _]), K = o.useMemo(() => ({
    v7_relativeSplatPath: n.future.v7_relativeSplatPath
  }), [n.future.v7_relativeSplatPath]);
  return /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(ae.Provider, {
    value: k
  }, /* @__PURE__ */ o.createElement(J.Provider, {
    value: r
  }, /* @__PURE__ */ o.createElement(Q.Provider, {
    value: g.current
  }, /* @__PURE__ */ o.createElement($.Provider, {
    value: f
  }, /* @__PURE__ */ o.createElement(M, {
    basename: _,
    location: r.location,
    navigationType: r.historyAction,
    navigator: v,
    future: K
  }, r.initialized || n.future.v7_partialHydration ? /* @__PURE__ */ o.createElement(jt, {
    routes: n.routes,
    future: n.future,
    state: r
  }) : t))))), null);
}
const jt = /* @__PURE__ */ o.memo(zt);
function zt(e) {
  let {
    routes: t,
    future: n,
    state: a
  } = e;
  return Ie(t, void 0, a, n);
}
function Wt(e) {
  let {
    basename: t,
    children: n,
    future: a,
    window: r
  } = e, s = o.useRef();
  s.current == null && (s.current = ge({
    window: r,
    v5Compat: !0
  }));
  let i = s.current, [u, f] = o.useState({
    action: i.action,
    location: i.location
  }), {
    v7_startTransition: l
  } = a || {}, c = o.useCallback((d) => {
    l && L ? L(() => f(d)) : f(d);
  }, [f, l]);
  return o.useLayoutEffect(() => i.listen(c), [i, c]), /* @__PURE__ */ o.createElement(M, {
    basename: t,
    children: n,
    location: u.location,
    navigationType: u.action,
    navigator: i,
    future: a
  });
}
function Yt(e) {
  let {
    basename: t,
    children: n,
    future: a,
    window: r
  } = e, s = o.useRef();
  s.current == null && (s.current = Re({
    window: r,
    v5Compat: !0
  }));
  let i = s.current, [u, f] = o.useState({
    action: i.action,
    location: i.location
  }), {
    v7_startTransition: l
  } = a || {}, c = o.useCallback((d) => {
    l && L ? L(() => f(d)) : f(d);
  }, [f, l]);
  return o.useLayoutEffect(() => i.listen(c), [i, c]), /* @__PURE__ */ o.createElement(M, {
    basename: t,
    children: n,
    location: u.location,
    navigationType: u.action,
    navigator: i,
    future: a
  });
}
function Ce(e) {
  let {
    basename: t,
    children: n,
    future: a,
    history: r
  } = e, [s, i] = o.useState({
    action: r.action,
    location: r.location
  }), {
    v7_startTransition: u
  } = a || {}, f = o.useCallback((l) => {
    u && L ? L(() => i(l)) : i(l);
  }, [i, u]);
  return o.useLayoutEffect(() => r.listen(f), [r, f]), /* @__PURE__ */ o.createElement(M, {
    basename: t,
    children: n,
    location: s.location,
    navigationType: s.action,
    navigator: r,
    future: a
  });
}
process.env.NODE_ENV !== "production" && (Ce.displayName = "unstable_HistoryRouter");
const qt = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Gt = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, ie = /* @__PURE__ */ o.forwardRef(function(t, n) {
  let {
    onClick: a,
    relative: r,
    reloadDocument: s,
    replace: i,
    state: u,
    target: f,
    to: l,
    preventScrollReset: c,
    viewTransition: d
  } = t, h = oe(t, Ft), {
    basename: S
  } = o.useContext(O), w, N = !1;
  if (typeof l == "string" && Gt.test(l) && (w = l, qt))
    try {
      let p = new URL(window.location.href), v = l.startsWith("//") ? new URL(p.protocol + l) : new URL(l), _ = P(v.pathname, S);
      v.origin === p.origin && _ != null ? l = _ + v.search + v.hash : N = !0;
    } catch {
      process.env.NODE_ENV !== "production" && H(!1, '<Link to="' + l + '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.');
    }
  let g = he(l, {
    relative: r
  }), C = xe(l, {
    replace: i,
    state: u,
    target: f,
    preventScrollReset: c,
    relative: r,
    viewTransition: d
  });
  function m(p) {
    a && a(p), p.defaultPrevented || C(p);
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ o.createElement("a", b({}, h, {
      href: w || g,
      onClick: N || s ? a : m,
      ref: n,
      target: f
    }))
  );
});
process.env.NODE_ENV !== "production" && (ie.displayName = "Link");
const Te = /* @__PURE__ */ o.forwardRef(function(t, n) {
  let {
    "aria-current": a = "page",
    caseSensitive: r = !1,
    className: s = "",
    end: i = !1,
    style: u,
    to: f,
    viewTransition: l,
    children: c
  } = t, d = oe(t, Pt), h = V(f, {
    relative: d.relative
  }), S = A(), w = o.useContext(J), {
    navigator: N,
    basename: g
  } = o.useContext(O), C = w != null && // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  Oe(h) && l === !0, m = N.encodeLocation ? N.encodeLocation(h).pathname : h.pathname, p = S.pathname, v = w && w.navigation && w.navigation.location ? w.navigation.location.pathname : null;
  r || (p = p.toLowerCase(), v = v ? v.toLowerCase() : null, m = m.toLowerCase()), v && g && (v = P(v, g) || v);
  const _ = m !== "/" && m.endsWith("/") ? m.length - 1 : m.length;
  let k = p === m || !i && p.startsWith(m) && p.charAt(_) === "/", K = v != null && (v === m || !i && v.startsWith(m) && v.charAt(m.length) === "/"), y = {
    isActive: k,
    isPending: K,
    isTransitioning: C
  }, T = k ? a : void 0, R;
  typeof s == "function" ? R = s(y) : R = [s, k ? "active" : null, K ? "pending" : null, C ? "transitioning" : null].filter(Boolean).join(" ");
  let B = typeof u == "function" ? u(y) : u;
  return /* @__PURE__ */ o.createElement(ie, b({}, d, {
    "aria-current": T,
    className: R,
    ref: n,
    style: B,
    to: f,
    viewTransition: l
  }), typeof c == "function" ? c(y) : c);
});
process.env.NODE_ENV !== "production" && (Te.displayName = "NavLink");
const se = /* @__PURE__ */ o.forwardRef((e, t) => {
  let {
    fetcherKey: n,
    navigate: a,
    reloadDocument: r,
    replace: s,
    state: i,
    method: u = W,
    action: f,
    onSubmit: l,
    relative: c,
    preventScrollReset: d,
    viewTransition: h
  } = e, S = oe(e, Dt), w = ue(), N = Pe(f, {
    relative: c
  }), g = u.toLowerCase() === "get" ? "get" : "post", C = (m) => {
    if (l && l(m), m.defaultPrevented) return;
    m.preventDefault();
    let p = m.nativeEvent.submitter, v = (p == null ? void 0 : p.getAttribute("formmethod")) || u;
    w(p || m.currentTarget, {
      fetcherKey: n,
      method: v,
      navigate: a,
      replace: s,
      state: i,
      relative: c,
      preventScrollReset: d,
      viewTransition: h
    });
  };
  return /* @__PURE__ */ o.createElement("form", b({
    ref: t,
    method: g,
    action: N,
    onSubmit: r ? l : C
  }, S));
});
process.env.NODE_ENV !== "production" && (se.displayName = "Form");
function _e(e) {
  let {
    getKey: t,
    storageKey: n
  } = e;
  return De({
    getKey: t,
    storageKey: n
  }), null;
}
process.env.NODE_ENV !== "production" && (_e.displayName = "ScrollRestoration");
var D;
(function(e) {
  e.UseScrollRestoration = "useScrollRestoration", e.UseSubmit = "useSubmit", e.UseSubmitFetcher = "useSubmitFetcher", e.UseFetcher = "useFetcher", e.useViewTransitionState = "useViewTransitionState";
})(D || (D = {}));
var I;
(function(e) {
  e.UseFetcher = "useFetcher", e.UseFetchers = "useFetchers", e.UseScrollRestoration = "useScrollRestoration";
})(I || (I = {}));
function Le(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function Z(e) {
  let t = o.useContext(ae);
  return t || (process.env.NODE_ENV !== "production" ? E(!1, Le(e)) : E(!1)), t;
}
function le(e) {
  let t = o.useContext(J);
  return t || (process.env.NODE_ENV !== "production" ? E(!1, Le(e)) : E(!1)), t;
}
function xe(e, t) {
  let {
    target: n,
    replace: a,
    state: r,
    preventScrollReset: s,
    relative: i,
    viewTransition: u
  } = t === void 0 ? {} : t, f = ne(), l = A(), c = V(e, {
    relative: i
  });
  return o.useCallback((d) => {
    if (Ct(d, n)) {
      d.preventDefault();
      let h = a !== void 0 ? a : q(l) === q(c);
      f(e, {
        replace: h,
        state: r,
        preventScrollReset: s,
        relative: i,
        viewTransition: u
      });
    }
  }, [l, f, c, a, r, n, e, s, i, u]);
}
function Jt(e) {
  process.env.NODE_ENV !== "production" && H(typeof URLSearchParams < "u", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
  let t = o.useRef(G(e)), n = o.useRef(!1), a = A(), r = o.useMemo(() => (
    // Only merge in the defaults if we haven't yet called setSearchParams.
    // Once we call that we want those to take precedence, otherwise you can't
    // remove a param with setSearchParams({}) if it has an initial value
    Tt(a.search, n.current ? null : t.current)
  ), [a.search]), s = ne(), i = o.useCallback((u, f) => {
    const l = G(typeof u == "function" ? u(r) : u);
    n.current = !0, s("?" + l, f);
  }, [s, r]);
  return [r, i];
}
function Xt() {
  if (typeof document > "u")
    throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $t = 0, Fe = () => "__" + String(++$t) + "__";
function ue() {
  let {
    router: e
  } = Z(D.UseSubmit), {
    basename: t
  } = o.useContext(O), n = pe();
  return o.useCallback(function(a, r) {
    r === void 0 && (r = {}), Xt();
    let {
      action: s,
      method: i,
      encType: u,
      formData: f,
      body: l
    } = xt(a, t);
    if (r.navigate === !1) {
      let c = r.fetcherKey || Fe();
      e.fetch(c, n, r.action || s, {
        preventScrollReset: r.preventScrollReset,
        formData: f,
        body: l,
        formMethod: r.method || i,
        formEncType: r.encType || u,
        flushSync: r.flushSync
      });
    } else
      e.navigate(r.action || s, {
        preventScrollReset: r.preventScrollReset,
        formData: f,
        body: l,
        formMethod: r.method || i,
        formEncType: r.encType || u,
        replace: r.replace,
        state: r.state,
        fromRouteId: n,
        flushSync: r.flushSync,
        viewTransition: r.viewTransition
      });
  }, [e, t, n]);
}
function Pe(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t, {
    basename: a
  } = o.useContext(O), r = o.useContext(re);
  r || (process.env.NODE_ENV !== "production" ? E(!1, "useFormAction must be used inside a RouteContext") : E(!1));
  let [s] = r.matches.slice(-1), i = b({}, V(e || ".", {
    relative: n
  })), u = A();
  if (e == null) {
    i.search = u.search;
    let f = new URLSearchParams(i.search), l = f.getAll("index");
    if (l.some((d) => d === "")) {
      f.delete("index"), l.filter((h) => h).forEach((h) => f.append("index", h));
      let d = f.toString();
      i.search = d ? "?" + d : "";
    }
  }
  return (!e || e === ".") && s.route.index && (i.search = i.search ? i.search.replace(/^\?/, "?index&") : "?index"), a !== "/" && (i.pathname = i.pathname === "/" ? a : st([a, i.pathname])), q(i);
}
function Qt(e) {
  var t;
  let {
    key: n
  } = e === void 0 ? {} : e, {
    router: a
  } = Z(D.UseFetcher), r = le(I.UseFetcher), s = o.useContext(Q), i = o.useContext(re), u = (t = i.matches[i.matches.length - 1]) == null ? void 0 : t.route.id;
  s || (process.env.NODE_ENV !== "production" ? E(!1, "useFetcher must be used inside a FetchersContext") : E(!1)), i || (process.env.NODE_ENV !== "production" ? E(!1, "useFetcher must be used inside a RouteContext") : E(!1)), u == null && (process.env.NODE_ENV !== "production" ? E(!1, 'useFetcher can only be used on routes that contain a unique "id"') : E(!1));
  let f = de ? de() : "", [l, c] = o.useState(n || f);
  n && n !== l ? c(n) : l || c(Fe()), o.useEffect(() => (a.getFetcher(l), () => {
    a.deleteFetcher(l);
  }), [a, l]);
  let d = o.useCallback((m, p) => {
    u || (process.env.NODE_ENV !== "production" ? E(!1, "No routeId available for fetcher.load()") : E(!1)), a.fetch(l, u, m, p);
  }, [l, u, a]), h = ue(), S = o.useCallback((m, p) => {
    h(m, b({}, p, {
      navigate: !1,
      fetcherKey: l
    }));
  }, [l, h]), w = o.useMemo(() => {
    let m = /* @__PURE__ */ o.forwardRef((p, v) => /* @__PURE__ */ o.createElement(se, b({}, p, {
      navigate: !1,
      fetcherKey: l,
      ref: v
    })));
    return process.env.NODE_ENV !== "production" && (m.displayName = "fetcher.Form"), m;
  }, [l]), N = r.fetchers.get(l) || lt, g = s.get(l);
  return o.useMemo(() => b({
    Form: w,
    submit: S,
    load: d
  }, N, {
    data: g
  }), [w, S, d, N, g]);
}
function Zt() {
  let e = le(I.UseFetchers);
  return Array.from(e.fetchers.entries()).map((t) => {
    let [n, a] = t;
    return b({}, a, {
      key: n
    });
  });
}
const me = "react-router-scroll-positions";
let z = {};
function De(e) {
  let {
    getKey: t,
    storageKey: n
  } = e === void 0 ? {} : e, {
    router: a
  } = Z(D.UseScrollRestoration), {
    restoreScrollPosition: r,
    preventScrollReset: s
  } = le(I.UseScrollRestoration), {
    basename: i
  } = o.useContext(O), u = A(), f = ye(), l = we();
  o.useEffect(() => (window.history.scrollRestoration = "manual", () => {
    window.history.scrollRestoration = "auto";
  }), []), tn(o.useCallback(() => {
    if (l.state === "idle") {
      let c = (t ? t(u, f) : null) || u.key;
      z[c] = window.scrollY;
    }
    try {
      sessionStorage.setItem(n || me, JSON.stringify(z));
    } catch (c) {
      process.env.NODE_ENV !== "production" && H(!1, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (" + c + ").");
    }
    window.history.scrollRestoration = "auto";
  }, [n, t, l.state, u, f])), typeof document < "u" && (o.useLayoutEffect(() => {
    try {
      let c = sessionStorage.getItem(n || me);
      c && (z = JSON.parse(c));
    } catch {
    }
  }, [n]), o.useLayoutEffect(() => {
    let c = t && i !== "/" ? (h, S) => t(
      // Strip the basename to match useLocation()
      b({}, h, {
        pathname: P(h.pathname, i) || h.pathname
      }),
      S
    ) : t, d = a == null ? void 0 : a.enableScrollRestoration(z, () => window.scrollY, c);
    return () => d && d();
  }, [a, i, t]), o.useLayoutEffect(() => {
    if (r !== !1) {
      if (typeof r == "number") {
        window.scrollTo(0, r);
        return;
      }
      if (u.hash) {
        let c = document.getElementById(decodeURIComponent(u.hash.slice(1)));
        if (c) {
          c.scrollIntoView();
          return;
        }
      }
      s !== !0 && window.scrollTo(0, 0);
    }
  }, [u, r, s]));
}
function en(e, t) {
  let {
    capture: n
  } = t || {};
  o.useEffect(() => {
    let a = n != null ? {
      capture: n
    } : void 0;
    return window.addEventListener("beforeunload", e, a), () => {
      window.removeEventListener("beforeunload", e, a);
    };
  }, [e, n]);
}
function tn(e, t) {
  let {
    capture: n
  } = {};
  o.useEffect(() => {
    let a = n != null ? {
      capture: n
    } : void 0;
    return window.addEventListener("pagehide", e, a), () => {
      window.removeEventListener("pagehide", e, a);
    };
  }, [e, n]);
}
function nn(e) {
  let {
    when: t,
    message: n
  } = e, a = Ee(t);
  o.useEffect(() => {
    a.state === "blocked" && (window.confirm(n) ? setTimeout(a.proceed, 0) : a.reset());
  }, [a, n]), o.useEffect(() => {
    a.state === "blocked" && !t && a.reset();
  }, [a, t]);
}
function Oe(e, t) {
  t === void 0 && (t = {});
  let n = o.useContext($);
  n == null && (process.env.NODE_ENV !== "production" ? E(!1, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?") : E(!1));
  let {
    basename: a
  } = Z(D.useViewTransitionState), r = V(e, {
    relative: t.relative
  });
  if (!n.isTransitioning)
    return !1;
  let s = P(n.currentLocation.pathname, a) || n.currentLocation.pathname, i = P(n.nextLocation.pathname, a) || n.nextLocation.pathname;
  return te(r.pathname, i) != null || te(r.pathname, s) != null;
}
const on = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortedDeferredError: ut,
  Await: Ve,
  BrowserRouter: Wt,
  Form: se,
  HashRouter: Yt,
  Link: ie,
  MemoryRouter: Me,
  NavLink: Te,
  Navigate: He,
  get NavigationType() {
    return ct;
  },
  Outlet: Ke,
  Route: Be,
  Router: M,
  RouterProvider: Bt,
  Routes: je,
  ScrollRestoration: _e,
  UNSAFE_DataRouterContext: ae,
  UNSAFE_DataRouterStateContext: J,
  UNSAFE_ErrorResponseImpl: be,
  UNSAFE_FetchersContext: Q,
  UNSAFE_LocationContext: ze,
  UNSAFE_NavigationContext: O,
  UNSAFE_RouteContext: re,
  UNSAFE_ViewTransitionContext: $,
  UNSAFE_useRouteId: pe,
  UNSAFE_useScrollRestoration: De,
  createBrowserRouter: At,
  createHashRouter: kt,
  createMemoryRouter: We,
  createPath: q,
  createRoutesFromChildren: ce,
  createRoutesFromElements: ce,
  createSearchParams: G,
  defer: ft,
  generatePath: dt,
  isRouteErrorResponse: mt,
  json: ht,
  matchPath: te,
  matchRoutes: pt,
  parsePath: vt,
  redirect: yt,
  redirectDocument: wt,
  renderMatches: Ye,
  replace: Et,
  resolvePath: St,
  unstable_HistoryRouter: Ce,
  unstable_usePrompt: nn,
  useActionData: qe,
  useAsyncError: Ge,
  useAsyncValue: Je,
  useBeforeUnload: en,
  useBlocker: Ee,
  useFetcher: Qt,
  useFetchers: Zt,
  useFormAction: Pe,
  useHref: he,
  useInRouterContext: Xe,
  useLinkClickHandler: xe,
  useLoaderData: $e,
  useLocation: A,
  useMatch: Qe,
  useMatches: ye,
  useNavigate: ne,
  useNavigation: we,
  useNavigationType: Ze,
  useOutlet: et,
  useOutletContext: tt,
  useParams: nt,
  useResolvedPath: V,
  useRevalidator: rt,
  useRouteError: at,
  useRouteLoaderData: ot,
  useRoutes: it,
  useSearchParams: Jt,
  useSubmit: ue,
  useViewTransitionState: Oe
}, Symbol.toStringTag, { value: "Module" }));
export {
  ie as L,
  Te as N,
  Bt as R,
  on as d,
  Jt as u
};
//# sourceMappingURL=index-Yn8c3UWE.js.map
